import React from 'react';
import ContentBox from '../components/ContentBox';
import './pages.css';

function Services() {
  return (
    <div>
      <ContentBox>
        <h2>Electrical & Mechanical Services</h2>
        <h3>Residential, Commercial, and Industrial Solutions</h3>
        <p>Chandliere Services Whether you need electrical or mechanical work for your home, business, or industrial facility, we provide comprehensive solutions. From wiring and system installations to maintenance and troubleshooting, we ensure safe, efficient, and reliable operations.</p>
        <h3>Electromechanical Systems</h3>
        <p>Specializing in the integration of electrical and mechanical components, we deliver high-performance systems for automation, manufacturing, and energy management.</p>
      </ContentBox>

      <ContentBox>
        <h2>Heating & Cooling Services</h2>
        <h3>Furnace Services</h3>
        <p>We provide expert furnace installation, repair, and maintenance to keep your space warm and energy-efficient. Our technicians handle all types of furnaces, ensuring they operate at peak performance.</p>
        <h3>HVAC Systems</h3>
        <p>From air conditioning installation to heating system maintenance, we deliver customized HVAC solutions to create a comfortable indoor environment year-round.</p>
      </ContentBox>

      <ContentBox>
        <h2>GeoThermal Heat Pump System</h2>
        <h3>Repair, installation, fixing, editing</h3>
        <p>Safety and precision are our priorities when it comes to gas services. We install, inspect, and maintain gas lines for appliances, heating systems, and industrial equipment, ensuring compliance with all safety regulations.</p>
        <h3>Custom Projects</h3>
        <p>Our skilled welders handle projects of all sizes, offering structural welding, repairs, and custom fabrication for residential, commercial, and industrial applications.</p>
      </ContentBox>

      <ContentBox>
        <h2>Restaurant Services</h2>
        <h3>Custom Hood & Duct Services</h3>
        <ul>
          <li>Walk-in Cooler services, Ducts for restaurants</li>
        </ul>
        <h3>Fridge and appliance fixing and reparation</h3>
        <p>Professional installation, repair, and cleaning of ventilation systems for residential, commercial, and industrial facilities.</p>
      </ContentBox>

      <ContentBox>
        <h2>Gas Services</h2>
        <h3>Gas Line Installation & Maintenance</h3>
        <p>Safety and precision are our priorities when it comes to gas services. We install, inspect, and maintain gas lines for appliances, heating systems, and industrial equipment, ensuring compliance with all safety regulations.</p>
        <h3>Custom Projects</h3>
        <p>Our skilled welders handle projects of all sizes, offering structural welding, repairs, and custom fabrication for residential, commercial, and industrial applications.</p>
      </ContentBox>

      <ContentBox>
        <h2>Welding Services</h2>
        <h3>Welding Installation & Maintenance</h3>
        <p>Safety and precision are our priorities when it comes to gas services. We install, inspect, and maintain gas lines for appliances, heating systems, and industrial equipment, ensuring compliance with all safety regulations.</p>
        <h3>Custom Welding Projects</h3>
        <p>Our skilled welders handle projects of all sizes, offering structural welding, repairs, and custom fabrication for residential, commercial, and industrial applications.</p>
      </ContentBox>

      <ContentBox>
        <h2>Core Services</h2>
        <h3>Electrical Services</h3>
        <p>We handle all aspects of electrical work, including wiring, panel upgrades, circuit installations, lighting solutions, and troubleshooting for residential and commercial properties.</p>
        <h3>Mechanical Services</h3>
        <ul>
          <li>Hydraulic & Pneumatic Systems</li>
          <li>Machinery Repairs & Maintenance</li>
        </ul>
      </ContentBox>

      <ContentBox>
        <h2>Automation & Control Systems</h2>
        <h3>PLC Programming</h3>
        <p>We provide programming, troubleshooting, and optimization of Programmable Logic Controllers (PLCs) for industrial automation, streamlining your processes for increased productivity.</p>
        <h3>Control System Design</h3>
        <p>Custom control system solutions tailored to your business needs, offering reliability, scalability, and precision for automated processes.</p>
      </ContentBox>

      <ContentBox>
        <h2>Smart Solutions</h2>
        <h3>Security Systems</h3>
        <p>Protect your property with our advanced security systems, including CCTV cameras, motion detectors, and alarm systems tailored to your specific requirements.</p>
        <h3>Smart Home Technology</h3>
        <p>Transform your living space with smart home integrations, such as automated lighting, thermostats, security systems, and voice-controlled devices.</p>
      </ContentBox>

      <ContentBox>
        <h2>Specialized Services</h2>
        <h3>Custom Design Services</h3>
        <ul>
          <li>Circle Design - Innovative and precise solutions for mechanical, architectural, or artistic applications</li>
          <li>Renewable Energy Systems - Design and installation of solar panels and wind turbines</li>
        </ul>
        <h3>Hood & Duct Services</h3>
        <p>Professional installation, repair, and cleaning of ventilation systems for residential, commercial, and industrial facilities.</p>
        <h3>Programming Services</h3>
        <p>Custom software & control programming solutions for industrial controls and data integration.</p>
      </ContentBox>
    </div>
  );
}

export default Services; 